import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import axios from "axios";
import { normalizarErrorApi } from "@/utils/erroresApi";

// Un 422 de FastAPI trae `detail` como lista de objetos; sin esto, cualquier
// toast.error(detail) tumbaba React y el aplicativo quedaba en blanco.
axios.interceptors.response.use((r) => r, normalizarErrorApi);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
